import styled from 'styled-components';

import { Colors, Styling } from '../../constants';

// Matches the header's own chrome (transparent on dark) rather than using VaultButton,
// which is styled for light dialog surfaces.
export const HeaderButton = styled.button`
  padding: 4px 10px;
  border: 1px solid ${Colors.WHITE_30};
  border-radius: ${Styling.DEFAULT_BORDER_RADIUS}px;
  background-color: ${Colors.WHITE_20};
  color: ${Colors.WHITE_90};
  font-size: ${Styling.HEADER_FONT_SIZE}px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: ${Colors.WHITE_30};
  }
`;
